import { render, staticRenderFns } from "./TemplateExtraVariablesPopover.vue?vue&type=template&id=7e8fd575"
import script from "./TemplateExtraVariablesPopover.vue?vue&type=script&lang=js"
export * from "./TemplateExtraVariablesPopover.vue?vue&type=script&lang=js"
import style0 from "./TemplateExtraVariablesPopover.vue?vue&type=style&index=0&id=7e8fd575&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports